import { render, staticRenderFns } from "./OfficialStockListPopover.vue?vue&type=template&id=740eddf2&"
import script from "./OfficialStockListPopover.vue?vue&type=script&lang=js&"
export * from "./OfficialStockListPopover.vue?vue&type=script&lang=js&"
import style0 from "./OfficialStockListPopover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports